import type {
  BookingToken,
  Booking,
} from './declarations'

// ***
// BOOKING TOKEN MOCKS
// ***
export const bookingTokenMock: BookingToken = {
  token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJib29raW5nSGFzaCI6IjFhMzdkN2ZiYTQxYWVmM2IxYjJkYmZiOTliMTQ2YTczMjQ1ZDZkMmQiLCJpYXQiOjE3MzI3NzY4NzQsImV4cCI6MTczMjc4MDQ3NH0.example',
}

export const bookingTokenResponseMock = {
  '@context': '/api/contexts/BookingToken',
  '@id': '/api/bookings/token',
  '@type': 'BookingToken',
  ...bookingTokenMock,
}

// ***
// BOOKING MOCKS
// ***
export const bookingMock: Booking = {
  hash: '1a37d7fba41aef3b1b2dbfb99b146a73245d6d2d',
  providerBookingId: '2fb1d0cb-a1da-4683-afaa-c5107aeab178',
  providerCalendarId: '1234567890',
  bookerEmail: 'alberto.lopez@siguetuliga.com',
  description: 'Pista de pádel 1h30',
  notes: 'Reserva para partido de pádel',
  startAt: '2024-11-28T15:00:00+00:00',
  endAt: '2024-11-28T16:30:00+00:00',
  amount: 500,
  currency: 'EUR',
  units: 1,
  status: 'confirmed',
  clubId: 'club-hash',
}

export const bookingWithUnitsMock: Booking = {
  ...bookingMock,
  units: 10,
}

export const bookingWithoutUnitsMock: Booking = {
  ...bookingMock,
  units: undefined,
}

export const bookingWithoutNotesMock: Booking = {
  ...bookingMock,
  notes: undefined,
}

export const bookingResponseMock = {
  '@context': '/api/contexts/Booking',
  '@id': '/api/bookings/14',
  '@type': 'Booking',
  ...bookingMock,
}

// ***
// MOCKS
// ***
export const bookingDataMock = {
  requestInternalState: { statusName: 'SUCCESS', isFetching: false },
  '@context': '/api/contexts/Booking',
  '@id': '/api/bookings/14',
  '@type': 'Booking',
  ...bookingMock,
}

export const multipleItemsBookingDataMock = { ...bookingDataMock, units: 10 }
export const zeroItemsBookingDataMock = { ...bookingDataMock, units: 0 }
export const undefinedItemsBookingDataMock = { ...bookingDataMock }

export const emptyBookingDataMock = {
  requestInternalState: { statusName: 'SUCCESS', isFetching: false },
  '@context': '/api/contexts/Booking',
  '@id': '/api/bookings/14',
  '@type': 'Booking',
  ...bookingMock,
  amount: 0,
}
